// src/app/core/core.module.ts
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AuthService } from './auth/auth.service';
import { TokenStorageService } from './auth/token-storage.service';

@NgModule({
    imports: [CommonModule],
    providers: [AuthService, TokenStorageService]
})
export class CoreModule {}
